export const FLEX_PACK_VOUCHER_SERVICE_FEE = 1;
export function parseFlexPackPrice(flexPack) {
    const raw = flexPack?.price;
    if (raw === null || raw === undefined || raw === '')
        return 0;
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : 0;
}
/** Sponsorship/comp flex packs have package price $0 and waive per-voucher fees. */
export function isCompFlexPack(flexPack) {
    return parseFlexPackPrice(flexPack) === 0;
}
export function getFlexPackVoucherCount(flexPack) {
    return Math.max(0, Math.floor(Number(flexPack?.gameTickets) || 0));
}
/** Blocktickets service fee: $1 per included voucher unless comp/sponsorship. */
export function getFlexPackVoucherServiceFee(flexPack) {
    if (isCompFlexPack(flexPack))
        return 0;
    return getFlexPackVoucherCount(flexPack) * FLEX_PACK_VOUCHER_SERVICE_FEE;
}
export function getFlexPackCartSubtotal(flexPack) {
    return parseFlexPackPrice(flexPack) + getFlexPackVoucherServiceFee(flexPack);
}
export function isZeroFeeCompFlexPackCart(flexPack) {
    return getFlexPackCartSubtotal(flexPack) === 0;
}
